import { getCurrentPage } from './get-current-page';

const landingLocation = typeof window === 'undefined' ? undefined : window.location;

const landingPage = landingLocation ? getCurrentPage(landingLocation.pathname) : undefined;

const landedFromCallback = landingLocation
  ? new URLSearchParams(landingLocation.search).has('callback')
  : false;

export const getLandingPage = (): string | undefined => landingPage;

export const resolveBootPage = (pathname: string): string | undefined => {
  if (landedFromCallback) return 'resultPage';

  return getLandingPage() ?? getCurrentPage(pathname);
};
